import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  hasNextRankById,
  nextRankDescriptionById,
  nextRankProgressById,
  rankDescriptionById,
  rankIdById,
} from '/redux/selector/coach.selector';

import {PersonalRankSummary} from './PersonalRankSummary';

export const PersonalRankSummaryConnected = connect(
  createStructuredSelector({
    rankId: rankIdById,
    rankName: rankDescriptionById,
    nextRankName: nextRankDescriptionById,
    percent: nextRankProgressById,
    hasNextRank: hasNextRankById,
  }),
)(PersonalRankSummary);
